"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTE_SOFTWARE = exports.ROUTE_SOFTWARE_OVERVIEW = exports.ROUTE_SOFTWARE_DETAIL = exports.ROUTE_REGISTRATION = exports.ROUTE_ASSETS = exports.ROUTE_ASSETS_OFFER_EXPANDED = exports.ROUTE_ASSETS_OFFER = exports.ROUTE_ASSETS_RETURN = exports.ROUTE_ASSETS_CUTTER_EXPANDED = exports.ROUTE_ASSETS_CUTTER = exports.ROUTE_ASSETS_SOFTWARE_EXPANDED = exports.ROUTE_ASSETS_SOFTWARE = exports.ROUTE_USER_PROFILE = exports.ROUTE_USER_PROFILE_ADDRESSES = exports.ROUTE_USER_PROFILE_ADMINISTRATION = exports.ROUTE_USER_PROFILE_ORDERS_EXPANDED = exports.ROUTE_USER_PROFILE_ORDERS = exports.ROUTE_USER_PROFILE_CONTACTS = exports.ROUTE_USER_PROFILE_ACCOUNT = exports.ROUTE_CHECKOUT = exports.ROUTE_CHECKOUT_FRONTPAGE = exports.ROUTE_CHECKOUT_CONFIRMATION = exports.ROUTE_CHECKOUT_PAY_ERROR = exports.ROUTE_CHECKOUT_PAY = exports.ROUTE_CHECKOUT_SUMMARY = exports.ROUTE_CHECKOUT_PAYMENT = exports.ROUTE_CHECKOUT_SHIPPING = exports.ROUTE_SHOP_CART = exports.ROUTE_REGISTRATION_SUCCESS = exports.ROUTE_REGISTRATION_VERIFY_COMPANY = exports.ROUTE_REGISTRATION_PERSONAL_INFORMATION = exports.ROUTE_REGISTRATION_SIGN_UP = exports.ROUTE_REGISTRATION_VERIFICATION_CODE = exports.ROUTE_REGISTRATION_COMPANY_INFORMATION = exports.ROUTE_RESELLER = exports.ROUTE_RESELLER_FILES = exports.ROUTE_MY_DOCUMENTS = exports.ROUTE_IOT = exports.ROUTE_DASHBOARD = exports.ROUTE_LOGIN = exports.ROUTE_HOME = void 0;
const auth0_react_1 = require("@auth0/auth0-react");
const react_1 = __importDefault(require("react"));
const react_router_config_1 = require("react-router-config");
const react_router_dom_1 = require("react-router-dom");
const AuthorizationScopes_1 = __importDefault(require("../../common/js/enums/AuthorizationScopes"));
const array_1 = require("../../common/js/helper/array");
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const AssetsCutter_1 = __importDefault(require("../components/assets/AssetsCutter"));
const AssetsCutterPage_1 = __importDefault(require("../components/assets/AssetsCutterPage"));
const AssetsOffer_1 = __importDefault(require("../components/assets/AssetsOffer"));
const AssetsOfferPage_1 = __importDefault(require("../components/assets/AssetsOfferPage"));
const AssetsReturnPage_1 = __importDefault(require("../components/assets/AssetsReturnPage"));
const AssetsSoftware_1 = __importDefault(require("../components/assets/AssetsSoftware"));
const AssetsSoftwarePage_1 = __importDefault(require("../components/assets/AssetsSoftwarePage"));
const ShopCheckoutConfirmation_1 = __importDefault(require("../components/checkout/ShopCheckoutConfirmation"));
const ShopCheckoutPay_1 = __importDefault(require("../components/checkout/ShopCheckoutPay"));
const ShopCheckoutPayError_1 = __importDefault(require("../components/checkout/ShopCheckoutPayError"));
const ShopCheckoutPayment_1 = __importDefault(require("../components/checkout/ShopCheckoutPayment"));
const ShopCheckoutShipping_1 = __importDefault(require("../components/checkout/ShopCheckoutShipping"));
const ShopCheckoutSummary_1 = __importDefault(require("../components/checkout/ShopCheckoutSummary"));
const AssetsPage_1 = __importDefault(require("../components/pages/AssetsPage"));
const DashboardPage_1 = __importDefault(require("../components/pages/DashboardPage"));
const IotPage_1 = __importDefault(require("../components/pages/IotPage"));
const MyDocumentsPage_1 = __importDefault(require("../components/pages/MyDocumentsPage"));
const RegistrationPage_1 = __importDefault(require("../components/pages/RegistrationPage"));
const ResellerAreaPage_1 = __importDefault(require("../components/pages/ResellerAreaPage"));
const ShopCartPage_1 = __importDefault(require("../components/pages/ShopCartPage"));
const ShopCheckoutPage_1 = __importDefault(require("../components/pages/ShopCheckoutPage"));
const ShopPage_1 = __importDefault(require("../components/pages/ShopPage"));
const SoftwarePage_1 = __importDefault(require("../components/pages/SoftwarePage"));
const UserProfilePage_1 = __importDefault(require("../components/pages/UserProfilePage"));
const UserProfileAccount_1 = __importDefault(require("../components/profile/UserProfileAccount"));
const UserProfileAddresses_1 = __importDefault(require("../components/profile/UserProfileAddresses"));
const UserProfileAdministration_1 = __importDefault(require("../components/profile/UserProfileAdministration"));
const UserProfileContacts_1 = __importDefault(require("../components/profile/UserProfileContacts"));
const UserProfileOrders_1 = __importDefault(require("../components/profile/UserProfileOrders"));
const RegistrationCompanyInformation_1 = __importDefault(require("../components/registration/RegistrationCompanyInformation"));
const RegistrationPersonalInformation_1 = __importDefault(require("../components/registration/RegistrationPersonalInformation"));
const RegistrationSignUp_1 = __importDefault(require("../components/registration/RegistrationSignUp"));
const RegistrationSuccess_1 = __importDefault(require("../components/registration/RegistrationSuccess"));
const RegistrationVerificationCode_1 = __importDefault(require("../components/registration/RegistrationVerificationCode"));
const RegistrationVerifyCompany_1 = __importDefault(require("../components/registration/RegistrationVerifyCompany"));
const ResellerFiles_1 = __importDefault(require("../components/reseller/ResellerFiles"));
const ShopCategory_1 = __importDefault(require("../components/shop/ShopCategory"));
const ShopHomePage_1 = __importDefault(require("../components/shop/ShopHomePage"));
const ShopProduct_1 = __importDefault(require("../components/shop/ShopProduct"));
const ShopSearchResult_1 = __importDefault(require("../components/shop/ShopSearchResult"));
const SoftwareDetailPage_1 = __importDefault(require("../components/software/SoftwareDetailPage"));
const SoftwareOverviewPage_1 = __importDefault(require("../components/software/SoftwareOverviewPage"));
const LocalStorageKeys_1 = __importDefault(require("../enums/LocalStorageKeys"));
const path_1 = require("../helper/path");
const ShopwareCart_1 = __importDefault(require("../stores/ShopwareCart"));
const Paths = __importStar(require("./Paths"));
exports.ROUTE_HOME = {
    path: Paths.PATH_HOME,
    component: (0, auth0_react_1.withAuth0)((props) => {
        if (AuthorizationStore_1.default.hasScope(AuthorizationScopes_1.default.REGISTRATION_CREATE)) {
            return react_1.default.createElement(react_router_dom_1.Redirect, { to: (0, path_1.localePath)(Paths.PATH_REGISTRATION) });
        }
        // Try to return the user to where they came from.
        // @ts-expect-error "returnTo" is untyped.
        const returnTo = props?.location?.state?.returnTo ?? null;
        if (!!returnTo) {
            return react_1.default.createElement(react_router_dom_1.Redirect, { to: returnTo });
        }
        if (AuthorizationStore_1.default.hasScope(AuthorizationScopes_1.default.DASHBOARD)) {
            return react_1.default.createElement(react_router_dom_1.Redirect, { to: (0, path_1.localePath)(Paths.PATH_DASHBOARD) });
        }
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: (0, path_1.localePath)(Paths.PATH_SHOP) });
    }),
};
exports.ROUTE_LOGIN = {
    path: Paths.PATH_LOGIN,
    component: (0, auth0_react_1.withAuth0)((props) => {
        // @ts-expect-error "returnTo" is untyped.
        const returnTo = props?.location?.state?.returnTo ?? (0, path_1.localePath)(Paths.PATH_HOME);
        const dashboardRedirects = [Paths.PATH_SHOP, Paths.PATH_USER_PROFILE, Paths.PATH_USER_PROFILE_ACCOUNT];
        const isDashboardRedirect = dashboardRedirects.some((path) => null !==
            (0, react_router_dom_1.matchPath)(returnTo, {
                exact: true, // So the shop home route is matched, but not category or product detail pages.
                path,
                strict: false, // Ignores trailing slash in path matching.
            }));
        localStorage.removeItem(LocalStorageKeys_1.default.popoverLoggedInClicked);
        props?.auth0?.loginWithRedirect({
            prompt: 'login',
            redirectUri: window.location.origin,
            appState: {
                returnTo: isDashboardRedirect ? (0, path_1.localePath)(Paths.PATH_DASHBOARD) : returnTo,
            },
        });
        return null;
    }),
};
exports.ROUTE_DASHBOARD = {
    path: Paths.PATH_DASHBOARD,
    component: DashboardPage_1.default,
};
exports.ROUTE_IOT = {
    path: Paths.PATH_IOT,
    scope: AuthorizationScopes_1.default.CONNECT_READ,
    component: IotPage_1.default,
};
exports.ROUTE_MY_DOCUMENTS = {
    path: Paths.PATH_MY_DOCUMENTS,
    scopes: [AuthorizationScopes_1.default.DOCUMENTS_READ],
    component: MyDocumentsPage_1.default,
};
exports.ROUTE_RESELLER_FILES = {
    path: Paths.PATH_RESELLER_FILES,
    scopes: [AuthorizationScopes_1.default.RESELLER_READ, AuthorizationScopes_1.default.RESELLER_DOCUMENTS_READ],
    component: ResellerFiles_1.default,
    tabNavigationShowForbidden: true,
    tabNavigationForbiddenTooltipKey: 'myinfohub.files.permission_denied',
};
exports.ROUTE_RESELLER = {
    path: Paths.PATH_RESELLER,
    scopes: [AuthorizationScopes_1.default.RESELLER_READ],
    component: ResellerAreaPage_1.default,
    routes: [exports.ROUTE_RESELLER_FILES],
};
exports.ROUTE_REGISTRATION_COMPANY_INFORMATION = {
    path: Paths.PATH_REGISTRATION_COMPANY_INFORMATION,
    component: RegistrationCompanyInformation_1.default,
};
exports.ROUTE_REGISTRATION_VERIFICATION_CODE = {
    path: Paths.PATH_REGISTRATION_VERIFICATION_CODE,
    component: RegistrationVerificationCode_1.default,
};
exports.ROUTE_REGISTRATION_SIGN_UP = {
    path: Paths.PATH_REGISTRATION_SIGN_UP,
    component: RegistrationSignUp_1.default,
};
exports.ROUTE_REGISTRATION_PERSONAL_INFORMATION = {
    path: Paths.PATH_REGISTRATION_PERSONAL_INFORMATION,
    component: RegistrationPersonalInformation_1.default,
};
exports.ROUTE_REGISTRATION_VERIFY_COMPANY = {
    path: Paths.PATH_REGISTRATION_VERIFY_COMPANY,
    component: RegistrationVerifyCompany_1.default,
};
exports.ROUTE_REGISTRATION_SUCCESS = {
    path: Paths.PATH_REGISTRATION_SUCCESS,
    component: RegistrationSuccess_1.default,
};
const ROUTE_SHOP = {
    path: Paths.PATH_SHOP,
    scope: AuthorizationScopes_1.default.SHOP_READ,
    component: ShopPage_1.default,
    routes: [
        {
            path: Paths.PATH_SHOP_PRODUCTS_SEARCH,
            component: ShopSearchResult_1.default,
        },
        {
            path: Paths.PATH_SHOP_PRODUCT,
            component: ShopProduct_1.default,
        },
        {
            path: Paths.PATH_SHOP_PRODUCTS,
            component: ShopCategory_1.default,
        },
        {
            path: Paths.PATH_SHOP,
            component: ShopHomePage_1.default,
        },
    ],
};
exports.ROUTE_SHOP_CART = {
    path: Paths.PATH_SHOP_CART,
    component: ShopCartPage_1.default,
};
exports.ROUTE_CHECKOUT_SHIPPING = {
    path: Paths.PATH_SHOP_CHECKOUT_SHIPPING,
    component: ShopCheckoutShipping_1.default,
};
exports.ROUTE_CHECKOUT_PAYMENT = {
    path: Paths.PATH_SHOP_CHECKOUT_PAYMENT,
    component: ShopCheckoutPayment_1.default,
};
exports.ROUTE_CHECKOUT_SUMMARY = {
    path: Paths.PATH_SHOP_CHECKOUT_SUMMARY,
    component: ShopCheckoutSummary_1.default,
};
exports.ROUTE_CHECKOUT_PAY = {
    path: Paths.PATH_SHOP_CHECKOUT_PAY,
    component: ShopCheckoutPay_1.default,
};
exports.ROUTE_CHECKOUT_PAY_ERROR = {
    path: Paths.PATH_SHOP_CHECKOUT_PAY_ERROR,
    component: ShopCheckoutPayError_1.default,
};
exports.ROUTE_CHECKOUT_CONFIRMATION = {
    path: Paths.PATH_SHOP_CHECKOUT_CONFIRMATION,
    component: ShopCheckoutConfirmation_1.default,
};
exports.ROUTE_CHECKOUT_FRONTPAGE = {
    path: Paths.PATH_SHOP_CHECKOUT,
    component: () => react_1.default.createElement(react_router_dom_1.Redirect, { to: (0, path_1.localePath)(Paths.PATH_SHOP_CHECKOUT_SHIPPING) }),
};
exports.ROUTE_CHECKOUT = {
    path: Paths.PATH_SHOP_CHECKOUT,
    component: (props) => {
        const routeMatch = (0, array_1.first)((0, react_router_config_1.matchRoutes)([exports.ROUTE_CHECKOUT_CONFIRMATION], props.location.pathname));
        const isConfirmationRoute = routeMatch?.route.path === Paths.PATH_SHOP_CHECKOUT_CONFIRMATION;
        if (ShopwareCart_1.default.isOrderOnAccountBlocked && !isConfirmationRoute) {
            return react_1.default.createElement(react_router_dom_1.Redirect, { to: (0, path_1.localePath)(Paths.PATH_SHOP_CART) });
        }
        return react_1.default.createElement(ShopCheckoutPage_1.default, { ...props });
    },
    routes: [
        exports.ROUTE_CHECKOUT_SHIPPING,
        exports.ROUTE_CHECKOUT_PAYMENT,
        exports.ROUTE_CHECKOUT_SUMMARY,
        exports.ROUTE_CHECKOUT_PAY_ERROR,
        exports.ROUTE_CHECKOUT_PAY,
        exports.ROUTE_CHECKOUT_CONFIRMATION,
        exports.ROUTE_CHECKOUT_FRONTPAGE,
    ],
};
exports.ROUTE_USER_PROFILE_ACCOUNT = {
    path: Paths.PATH_USER_PROFILE_ACCOUNT,
    component: UserProfileAccount_1.default,
};
exports.ROUTE_USER_PROFILE_CONTACTS = {
    path: Paths.PATH_USER_PROFILE_CONTACTS,
    scope: AuthorizationScopes_1.default.COMPANY_READ,
    component: UserProfileContacts_1.default,
};
exports.ROUTE_USER_PROFILE_ORDERS = {
    path: Paths.PATH_USER_PROFILE_ORDERS,
    scope: AuthorizationScopes_1.default.ORDER_READ,
    component: UserProfileOrders_1.default,
};
exports.ROUTE_USER_PROFILE_ORDERS_EXPANDED = {
    path: Paths.PATH_USER_PROFILE_ORDERS_EXPANDED,
    scope: AuthorizationScopes_1.default.ORDER_READ,
    component: UserProfileOrders_1.default,
};
exports.ROUTE_USER_PROFILE_ADMINISTRATION = {
    path: Paths.PATH_USER_PROFILE_ADMINISTRATION,
    scope: AuthorizationScopes_1.default.ACCOUNT_READ,
    component: UserProfileAdministration_1.default,
};
exports.ROUTE_USER_PROFILE_ADDRESSES = {
    path: Paths.PATH_USER_PROFILE_ADDRESSES,
    scopes: [AuthorizationScopes_1.default.COMPANY_READ, AuthorizationScopes_1.default.ADDRESS_READ],
    component: UserProfileAddresses_1.default,
};
exports.ROUTE_USER_PROFILE = {
    path: Paths.PATH_USER_PROFILE,
    scope: AuthorizationScopes_1.default.PROFILE_READ,
    component: UserProfilePage_1.default,
    routes: [
        exports.ROUTE_USER_PROFILE_ACCOUNT,
        exports.ROUTE_USER_PROFILE_CONTACTS,
        exports.ROUTE_USER_PROFILE_ADMINISTRATION,
        exports.ROUTE_USER_PROFILE_ORDERS_EXPANDED,
        exports.ROUTE_USER_PROFILE_ORDERS,
        exports.ROUTE_USER_PROFILE_ADDRESSES,
    ],
};
exports.ROUTE_ASSETS_SOFTWARE = {
    path: Paths.PATH_ASSETS_SOFTWARE,
    scope: AuthorizationScopes_1.default.LICENSE_READ,
    component: AssetsSoftwarePage_1.default,
};
exports.ROUTE_ASSETS_SOFTWARE_EXPANDED = {
    path: Paths.PATH_ASSETS_SOFTWARE_EXPANDED,
    scope: AuthorizationScopes_1.default.LICENSE_READ,
    component: AssetsSoftware_1.default,
};
exports.ROUTE_ASSETS_CUTTER = {
    path: Paths.PATH_ASSETS_CUTTER,
    scope: AuthorizationScopes_1.default.MACHINE_READ,
    component: AssetsCutterPage_1.default,
};
exports.ROUTE_ASSETS_CUTTER_EXPANDED = {
    path: Paths.PATH_ASSETS_CUTTER_EXPANDED,
    scope: AuthorizationScopes_1.default.MACHINE_READ,
    component: AssetsCutter_1.default,
};
exports.ROUTE_ASSETS_RETURN = {
    path: Paths.PATH_ASSETS_RETURNS,
    scopes: [AuthorizationScopes_1.default.RETURN_READ],
    component: AssetsReturnPage_1.default,
};
exports.ROUTE_ASSETS_OFFER = {
    path: Paths.PATH_ASSETS_OFFER,
    scope: AuthorizationScopes_1.default.OFFER_READ,
    component: AssetsOfferPage_1.default,
    translationKey: 'myassets.offer',
};
exports.ROUTE_ASSETS_OFFER_EXPANDED = {
    path: Paths.PATH_ASSETS_OFFER_EXPANDED,
    scope: AuthorizationScopes_1.default.OFFER_READ,
    component: AssetsOffer_1.default,
};
exports.ROUTE_ASSETS = {
    path: Paths.PATH_ASSETS,
    component: AssetsPage_1.default,
    routes: [
        exports.ROUTE_ASSETS_CUTTER_EXPANDED,
        exports.ROUTE_ASSETS_CUTTER,
        exports.ROUTE_ASSETS_SOFTWARE_EXPANDED,
        exports.ROUTE_ASSETS_SOFTWARE,
        exports.ROUTE_ASSETS_OFFER_EXPANDED,
        exports.ROUTE_ASSETS_OFFER,
        exports.ROUTE_ASSETS_RETURN,
    ],
};
exports.ROUTE_REGISTRATION = {
    path: Paths.PATH_REGISTRATION,
    scope: AuthorizationScopes_1.default.REGISTRATION_CREATE,
    component: RegistrationPage_1.default,
    routes: [
        exports.ROUTE_REGISTRATION_VERIFY_COMPANY,
        exports.ROUTE_REGISTRATION_SUCCESS,
        exports.ROUTE_REGISTRATION_SIGN_UP,
        exports.ROUTE_REGISTRATION_VERIFICATION_CODE,
        exports.ROUTE_REGISTRATION_PERSONAL_INFORMATION,
        exports.ROUTE_REGISTRATION_COMPANY_INFORMATION,
    ],
};
exports.ROUTE_SOFTWARE_DETAIL = {
    path: Paths.PATH_SOFTWARE_DETAIL,
    scope: AuthorizationScopes_1.default.SOFTWARE_READ,
    component: (props) => {
        const product = props?.match.params?.product ?? null;
        const path = JSON.parse(__APP__.PATH_SOFTWARE_DETAIL);
        if (!!product && product in path) {
            return react_1.default.createElement(react_router_dom_1.Redirect, { to: (0, path_1.localePath)('/:locale' + path[product]) });
        }
        return react_1.default.createElement(SoftwareDetailPage_1.default, { ...props });
    },
};
exports.ROUTE_SOFTWARE_OVERVIEW = {
    path: Paths.PATH_SOFTWARE,
    scope: AuthorizationScopes_1.default.SOFTWARE_READ,
    component: SoftwareOverviewPage_1.default,
};
exports.ROUTE_SOFTWARE = {
    path: Paths.PATH_SOFTWARE,
    scope: AuthorizationScopes_1.default.SOFTWARE_READ,
    component: SoftwarePage_1.default,
    routes: [exports.ROUTE_SOFTWARE_DETAIL, exports.ROUTE_SOFTWARE_OVERVIEW],
};
/**
 * First matching route will be rendered. Therefore, '/' should always be at the end!
 */
const routes = [
    exports.ROUTE_CHECKOUT,
    exports.ROUTE_SHOP_CART,
    ROUTE_SHOP,
    exports.ROUTE_IOT,
    exports.ROUTE_MY_DOCUMENTS,
    exports.ROUTE_REGISTRATION,
    exports.ROUTE_RESELLER,
    exports.ROUTE_USER_PROFILE,
    exports.ROUTE_ASSETS,
    exports.ROUTE_SOFTWARE,
    exports.ROUTE_DASHBOARD,
    exports.ROUTE_LOGIN,
    exports.ROUTE_HOME,
];
exports.default = routes;
